// Lib
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash/fp';

// Selectors
import { individualTaskItemActivitySelector } from './selectors/boardActivitySelector';
import { createSelectIsElementSingleSelected } from '../selection/selectedElementsSelector';

// Components
import ActivityIndicator from './ActivityIndicator';

const createMapStateToProps = () =>
    createStructuredSelector({
        taskItemActivity: individualTaskItemActivitySelector(),
    });

/**
 * Shows an in-board activity badge on a V2 task-list node when it has unseen
 * assignment/reaction/label activity, mirroring `CommentActivityIndicator` /
 * `ElementActivityIndicator` for the task's own stable id.
 *
 * The owning element's selection is read here rather than passed in by the task item node
 * view, because Tiptap freezes extension options at editor creation (see `TaskListItem`).
 */
const TaskItemActivityIndicator = (props) => {
    const { taskItemActivity, taskId, elementId } = props;

    const selectIsElementSingleSelected = useMemo(() => createSelectIsElementSingleSelected(elementId), [elementId]);
    const isElementSingleSelected = useSelector(selectIsElementSingleSelected);

    if (isEmpty(taskItemActivity)) return null;

    return (
        <ActivityIndicator
            elementId={taskId}
            toggleVal={isElementSingleSelected}
            elementActivity={taskItemActivity}
        />
    );
};

TaskItemActivityIndicator.propTypes = {
    taskId: PropTypes.string,
    elementId: PropTypes.string,
    taskItemActivity: PropTypes.object,
};

export default connect(createMapStateToProps)(TaskItemActivityIndicator);
